/** @format */

import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { _$, Card, Button, Icon, Editable, Dialog, Message } from '@king-design/react'
import { CustomPageContainer, MonitorSearch } from 'src/components'
import CreateGroupDialog from 'src/containers/MonitorGroup/CreateGroupDialog'
import useFormTable from 'src/hooks/useFormTable'
import { TablePage, Divider } from 'src/components'
import { nameValidate } from 'src/config/validate'
import { request } from 'src/utils'
import useTableGroup from 'src/hooks/useTableGroup'
import ApiGroup from 'src/api/ApiGroup'

const MonitorGroup: React.FC<{ className?: string }> = ({ className }) => {
  const history = useHistory()
  const productList = useTableGroup('productList', 'pod')
  const [tableGroup, setTableGroup] = useState({
    resourceNumber: 999
  })
  const [query, setQuery] = useState<string>('')
  // 新建资源分组Dialog
  const [createVisible, setCreateVisible] = useState<boolean>(false)
  // 修改资源组名称
  const updateName = async (groupId, value) => {
    const result = await request(ApiGroup.modifyGroupName, {
      method: 'POST',
      data: {
        GroupId: groupId,
        GroupName: value
      }
    })
    if (result.code === 'Success') {
      Message.success(_$('编辑成功'))
      run()
    }
  }

  // 打开新建资源分组Dialog
  const createOpen = () => {
    setCreateVisible(true)
  }

  // 关闭新建资源分组Dialog
  const createClose = () => {
    setCreateVisible(false)
  }

  // 删除资源分组
  const deleteGroup = (gorupName: string, groupId: number) => {
    Dialog.confirm({
      content: _$('删除后关联告警模板将自动解除，确认删除资源分组吗？')
    }).then(async () => {
      const result = await request(ApiGroup.deleteGroup, {
        method: 'POST',
        data: {
          GroupId: groupId
        }
      })
      if (result.code === 'Success') {
        Message.success(_$('删除成功'))
        run({
          PageIndex: 1
        })
      }
    })
  }

  // 复制资源分组
  // const copyGroup = groupId => {
  //   Dialog.confirm({
  //     content: _$('确认复制当前资源分组吗？')
  //   }).then(async () => {
  //     const result = await request(ApiGroup.copyGroup, {
  //       method: 'POST',
  //       data: {
  //         GroupId: groupId
  //       }
  //     })
  //     if (result.code === 'Success') {
  //       Message.success(_$('复制成功'))
  //       run({
  //         PageIndex: 1
  //       })
  //     }
  //   })
  // }

  // table data
  const { run, result, total, pageState, loading } = useFormTable(
    ApiGroup.getResourceGroupList,
    {
      params: {
        ProductType: tableGroup.resourceNumber,
        GroupName: query
      }
    },
    data => ({
      tableData: data?.groupList || [],
      totalCount: data?.totalCount || 0
    })
  )

  const tableScheme = {
    groupName: {
      title: _$('资源分组名称'),
      template: item => {
        return (
          <Editable
            value={item.groupName}
            onChangeValue={value => {
              updateName(item.groupId, value)
            }}
            validate={value => {
              return value && nameValidate.validate.test(value)
            }}
          >
            <span>{item.groupName}</span>
          </Editable>
        )
      }
    },
    resourceNumber: {
      title: _$('关联实例'),
      group: productList,
      template(item) {
        return item.resourceNumber
      }
    },
    active: {
      title: _$('操作'),
      template: function (item) {
        return (
          <div className="ksc-space">
            {/* 管理 */}
            <a
              onClick={() => {
                history.push(`/monitor/group/details/${item.groupId}/${item.groupName}`)
              }}
            >
              {_$('查看')}
            </a>
            <Divider />
            {/* 复制 */}
            {/* <a
              onClick={() => {
                copyGroup(item.groupId)
              }}
            >
              {_$('复制')}
            </a>
            <Divider /> */}
            {/* 应用分组 */}
            {/* <a>{_$('应用分组')}</a>
            <Divider /> */}
            {/* 删除 */}

            <a
              onClick={() => {
                deleteGroup(item.groupName, item.groupId)
              }}
            >
              {_$('删除')}
            </a>
          </div>
        )
      }
    }
  }

  return (
    <div className={className}>
      <CustomPageContainer title={_$('资源分组')}>
        <Card type="none">
          <div className="header">
            <Button type="primary" onClick={createOpen}>
              <Icon className="ion-plus-round" />
              {_$('新建资源分组')}
            </Button>
            <MonitorSearch
              placeholder={_$(`请输入资源分组名称`)}
              value={query}
              onChange={value => {
                setQuery(value.trim())
                run({
                  PageIndex: 1,
                  GroupName: value.trim()
                })
              }}
            />
          </div>
          <TablePage
            tableProps={{
              stickHeader: 50,
              data: result,
              scheme: tableScheme,
              resizable: true,
              checkType: 'none',
              group: tableGroup,
              onChangeGroup: value => {
                setTableGroup(value)
                run({
                  PageIndex: 1,
                  ProductType: value.resourceNumber
                })
              }
            }}
            pageProps={{ total, ...pageState }}
            loading={loading}
            run={run}
          />
          <CreateGroupDialog
            visible={createVisible}
            onClose={createClose}
            update={() => {
              run({
                PageIndex: 1
              })
            }}
          />
        </Card>
      </CustomPageContainer>
    </div>
  )
}
export default styled(MonitorGroup)`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .k-editable {
    margin: 0;
    width: calc(100% - 20px);
  }
`
